import { useRootStore } from "store";
import { useParams } from "react-router";
import { useIsMobile } from "hooks/use-is-mobile";

import Message from "./message";
import { Icon } from "components/icon/Icon";
import { useGlobalContext } from "app/store/GlobalContext";

export default function MessagePreview() {
  const isMobile = useIsMobile();
  const { handleNavigation } = useGlobalContext();
  const { user: currentUser } = useRootStore((state) => state);
  const { sentMessages } = useRootStore((state) => state.inbox);
  const { messageId } = useParams();

  const msg = sentMessages.find((m) => {
    return m.messageId === `messages/${messageId}`;
  });

  if (!msg || !messageId) {
    return (
      <p className="placeholder">
        Välj en konversation för att visa dess innehåll.
      </p>
    );
  }

  const handleNavigateBack = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    handleNavigation({
      url: -1,
      eventTitle: "Back",
      e: e
    });
  };

  return (
    <div className="w-100 d-flex">
      {currentUser && (
        <>
          {isMobile && (
            <span className="thread-meta-arrow mr-2 mt-4">
              <Icon
                name={`fas fa-chevron-left cursor-pointer`}
                onClick={(e) => handleNavigateBack(e)}
              />
            </span>
          )}
          <Message message={msg} key={messageId} id={messageId} />
        </>
      )}
    </div>
  );
}
